import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

// Importação de componentes
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import PipelineDesigner from '../views/PipelineDesigner.vue'
import PipelineList from '../views/PipelineList.vue'
import ExecutionList from '../views/ExecutionList.vue'
import ExecutionDetail from '../views/ExecutionDetail.vue'
import ModuleList from '../views/ModuleList.vue'

// Admin views
import FuncionariosList from '../views/admin/FuncionariosList.vue'
import CadastrarFuncionario from '../views/admin/CadastrarFuncionario.vue'
import CadastrarLocalizacao from '../views/admin/CadastrarLocalizacao.vue'
import DashboardAdmin from '../views/admin/DashboardAdmin.vue'
import ConsultaPontos from '../views/admin/ConsultaPontos.vue'
import MeusPontos from '../views/MeusPontos.vue'
import FuncionarioPerfil from '../views/admin/FuncionarioPerfil.vue'
import LocalizacoesList from '../views/admin/LocalizacoesList.vue'
import AtribuirLocalizacao from '../views/admin/AtribuirLocalizacao.vue'
import Perfil from '../views/Perfil.vue'
import AdminFeriados from '../views/admin/AdminFeriados.vue' 
import AjustePonto from '../views/admin/AjustePonto.vue'


// Definição das rotas
const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/meus',
    name: 'MeusPontos',
    component: MeusPontos,
    meta: { requiresAuth: true }
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: Perfil,
    meta: { requiresAuth: true }
  },

  // Admin routes
  {
    path: '/admin/funcionarios',
    name: 'FuncionariosList',
    component: FuncionariosList,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  {
    path: '/admin/funcionarios/perfil/:id',
    name: 'FuncionarioPerfil',
    component: FuncionarioPerfil,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  {
    path: '/admin/funcionarios/novo',
    name: 'CadastrarFuncionario',
    component: CadastrarFuncionario,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  {
    path: '/admin/localizacao/novo',
    name: 'CadastrarLocalizacao',
    component: CadastrarLocalizacao,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  {
    path: '/admin/localizacoes',
    name: 'LocalizacoesList',
    component: LocalizacoesList,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  {
    path: '/admin/localizacoes/atribuir/:id',
    name: 'AtribuirLocalizacao',
    component: AtribuirLocalizacao,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  {
    path: '/admin/dashboard',
    name: 'DashboardAdmin',
    component: DashboardAdmin,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  {
    path: '/admin/funcionarios/pontos',
    name: 'ConsultaPontos',
    component: ConsultaPontos,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  {
    path: '/admin/feriados',
    name: 'AdminFeriados',
    component: AdminFeriados,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  {
    path: '/admin/funcionarios/ajustePonto',
    name: 'AjustePonto',
    component: AjustePonto,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Others
  {
    path: '/pipelines/new',
    name: 'NewPipeline',
    component: PipelineDesigner,
    meta: { requiresAuth: true }
  },
  {
    path: '/pipelines/:id',
    name: 'EditPipeline',
    component: PipelineDesigner,
    meta: { requiresAuth: true }
  },
  {
    path: '/executions',
    name: 'ExecutionList',
    component: ExecutionList,
    meta: { requiresAuth: true }
  },
  {
    path: '/executions/:id',
    name: 'ExecutionDetail',
    component: ExecutionDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/modules',
    name: 'ModuleList',
    component: ModuleList,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
})

// Navegação global - verificação de autenticação
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const isAuthenticated = store.getters.isAuthenticated
  const isAdmin = store.getters.isAdmin

  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (requiresAdmin && !isAdmin) {
    next('/dashboard')
  } else if (to.path === '/login' && isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
